import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  base: {
    content: {
      color: 'black !important',
    },
  },
  variants: {
    size: {
      lg: {
        content: {
          maxW: 'xl',
        },
      },
      '2xl': {
        content: {
          maxW: '6xl',
        },
      },
    },
  },
});
